import script from "./OrganizationDocuments.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationDocuments.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationDocuments.vue?vue&type=style&index=0&id=511f1f7b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511f1f7b"]])

export default __exports__